/**
 * Auth Service
 * 
 * Handles JWT token storage and authentication state.
 * 
 * Requirements:
 * - US3: Admin authentication
 */

const TOKEN_KEY = 'admin_token';

/**
 * Save JWT token to localStorage
 */
export function saveToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

/**
 * Get JWT token from localStorage
 */
export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

/**
 * Remove JWT token from localStorage
 */
export function removeToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

/**
 * Check if user is authenticated
 */
export function isAuthenticated(): boolean {
  const token = getToken();
  
  if (!token) {
    return false;
  }

  // Simple JWT expiry check (decode payload)
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp;
    
    if (!exp) {
      return true; // No expiry set
    }
    
    // Check if token is expired
    return Date.now() < exp * 1000;
  } catch (error) {
    console.error('Failed to parse token:', error);
    return false;
  }
}

/**
 * Get decoded admin info from token
 */
export function getAdminInfo(): { adminId: string; email: string } | null {
  const token = getToken();
  
  if (!token) {
    return null;
  }

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return {
      adminId: payload.adminId,
      email: payload.email,
    };
  } catch (error) {
    console.error('Failed to parse token:', error);
    return null;
  }
}
